"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddWalletRequestBodyToJSON = exports.AddWalletRequestBodyFromJSONTyped = exports.AddWalletRequestBodyFromJSON = void 0;
function AddWalletRequestBodyFromJSON(json) {
    return AddWalletRequestBodyFromJSONTyped(json, false);
}
exports.AddWalletRequestBodyFromJSON = AddWalletRequestBodyFromJSON;
function AddWalletRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signature': json['signature'],
        'publicKey': json['publicKey'],
    };
}
exports.AddWalletRequestBodyFromJSONTyped = AddWalletRequestBodyFromJSONTyped;
function AddWalletRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signature': value.signature,
        'publicKey': value.publicKey,
    };
}
exports.AddWalletRequestBodyToJSON = AddWalletRequestBodyToJSON;
